//
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import ProductModel from '@/models/Warehouse/WhProductToSearch'
import ProductServiceModel from '@/models/Warehouse/WhProductService'
import ProviderModel from '@/models/Purchase/PchProvider'
import PurchaseOrderDetailModel from '@/models/Purchase/PchDetailPurchaseOrder'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'
import UserModel from '@/models/General/GUser'

//
import DetailPurchaseOrderHeaders from '@/views/Purchase/PchPurchaseOrder/PchDetailPurchaseOrderHeaders'
import ProductFilters from '@/views/Warehouse/WhProduct/list/filters'
import ProductHeaders from '@/views/Warehouse/WhProduct/WhProductHeaders'
import ProductServiceFilters from '@/views/Warehouse/WhProductService/WhProductServiceFilters'
import ProductServiceHeaders from '@/views/Warehouse/WhProductService/WhProductServiceHeaders'

//
import { required } from '@/services/validations'
import {
    PurchaseOrderDetailHeaders,
    PurchaseOrderOrdererHeaders,
} from './headers'

//
import { RequiredRule } from '@/mixins/reusable_mixins/rules'

/**
 * @description
 * Parser of selected collection 'pch_selected_purchase_orders'
 *
 * @param      {object}  props   properties
 * @return     {DetailPurchaseOrder}  detail purchase order class
 */
const selected_parser = props => row => row.toDetailPurchaseOrder({ 
    g_branch_office_id: props.g_branch_office_id 
})

//
export default props => [
    {
        name: 'g_originator_user_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin usuarios.',
            noObject: true,
            readonly: true,
            rules: [RequiredRule],
        },
    },
    {
        name: 'wh_warehouse_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            noDataText: 'Sin usuarios.',
            noObject: true,
            readonly: true,
            rules: [RequiredRule],
        },
    },
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'alias_name',
            itemValue: 'id',
            label: 'Proveedor',
            model: ProviderModel,
            noDataText: 'Sin proveedores.',
            noObject: true,
            readonly: true,
            rules: [RequiredRule],
        },
        trigger(ctx) {
            // get required info
            const branchField = ctx.getField('pch_provider_branch_offices_id'),
                branchSelected = ctx.value.pch_provider_branch_offices_id,
                providerInput = ctx.getInput('pch_provider_id'),
                providerSelected = providerInput.getSelected()

            // set new items
            branchField.props.items =
                providerSelected.branch_offices ||
                providerSelected.pch_provider_branch_offices ||
                []

            // refresh value input
            ctx.value.pch_provider_branch_offices_id = 0
            ctx.value.pch_provider_branch_offices_id = branchSelected

            // set loading true
            //branchField.props.loading = providerInput.loading

            // reset fieldset
            ctx.$refs.fieldset.$forceUpdate()
        },
    },
    {
        name: 'pch_provider_branch_offices_id',
        type: 'autocomplete',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            items: [],
            itemText: 'address',
            itemValue: 'id',
            label: 'Sucursal',
            noDataText: 'Sin sucursales.',
            noObject: true,
            readonly: true,
            rules: [RequiredRule],
        },
    },
    {
        name: 'pch_purchase_order_state_name',
        type: 'text-field',
        flex: {
            sm3: true,
            xs12: true,
        },
        props: {
            label: 'Estado',
            readonly: true,
        },
    },
    {
        name: 'invoiceNumbers',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Factura(s)',
            readonly: true,
        },
    },
    {
        name: 'created_at',
        type: 'date-field',
        flex: {
            sm3: true,
            xs12: true,
        },
        props: {
            label: 'Creado',
            readonly: true,
        },
    },
    {
        name: 'receiving_date',
        type: 'date-field',
        flex: {
            sm3: true,
            xs12: true,
        },
        props: {
            label: 'Recepcion',
            readonly: true,
        },
    },
    {
        name: 'pch_selected_purchase_orders',
        type: 'table-field',
        flex: {
            'pt-0': true,
            xs12: true,
            'd-grid': true,
        },
        props: {
            checkable: true,
            headers: PurchaseOrderDetailHeaders,
            noDataText: 'Sin productos.',
            selectedKey: props.is_service ? 'wh_product_service_id' : 'wh_product_id',
            toolbarTitle: 'Lista de productos incluidos en la orden',
        },
    },
    {
        name: 'pch_selected_purchase_orders_net_price',
        type: 'currency-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Total neto',
            readonly: true,
            reverse: true,
        },
    },
    {
        name: 'pch_selected_purchase_orders_net_price_real',
        type: 'currency-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Total neto real',
            readonly: true,
            reverse: true,
        },
    },
]
